export default {
  namespaced: true,

  state: {
    isShowTabs: true
  },

  getters: {
    isShowTabs: state => state.isShowTabs
  },

  mutations: {
    setIsShowTabs(state, isShowTabs) {
      state.isShowTabs = isShowTabs
    }
  },

  actions: {}
}
